import React, { Component } from 'react';
import { connect } from 'react-redux';
import PreviewExposureEventModal from '../../../../views/widget/common/modal/PreviewExposureEventModal';
import withModal from '../../../../lib/hoc/withModal';
import { widgetActions } from '../../../../store/modules/widget';
import { WIDGET_ITEM_EVENT_ATTACHMENT_TYPE } from '../../../../constants/service/app/widgetConstants';

class PreviewExposureEventModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'previewExposureEventModal', value: false });
  };

  render() {
    return <PreviewExposureEventModal {...this.state} {...this.props} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.widget.previewExposureEventModal.isOpen,
    exposureEventList: state.widget.widgetSave.exposureWidgetItemList.list
      .filter((item) => item.linkId)
      .map((item) => ({
        url: item.img[WIDGET_ITEM_EVENT_ATTACHMENT_TYPE.APP][0]
          ? item.img[WIDGET_ITEM_EVENT_ATTACHMENT_TYPE.APP][0].url
          : null,
        exposurePeriod: item.exposurePeriod,
      })),
  };
};

const mapDispatchToProps = {
  toggleModal: widgetActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(PreviewExposureEventModalContainer));
